type ClassValue = string | number | null | undefined | boolean | { [key: string]: unknown } | ClassValue[];

const classNames = (...args: ClassValue[]): string => {
    return args
        .flatMap((arg): (string | number)[] => {
            if (!arg) {
                return [];
            }

            if (typeof arg === 'string' || typeof arg === 'number') {
                return [arg];
            }

            if (Array.isArray(arg)) {
                const inner = classNames(...arg);

                return inner ? [inner] : [];
            }

            if (typeof arg === 'object') {
                return (
                    Object.entries(arg)
                        // eslint-disable-next-line no-unused-vars
                        .filter(([_, value]) => Boolean(value))
                        .map(([key]) => key)
                );
            }

            return [];
        })
        .join(' ');
};

export default classNames;
